import { render, staticRenderFns } from "./MarketDynamics.vue?vue&type=template&id=67a5710a&scoped=true"
import script from "./MarketDynamics.vue?vue&type=script&lang=js"
export * from "./MarketDynamics.vue?vue&type=script&lang=js"
import style0 from "./MarketDynamics.vue?vue&type=style&index=0&id=67a5710a&prod&scoped=true&lang=css"
import style1 from "./MarketDynamics.vue?vue&type=style&index=1&id=67a5710a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a5710a",
  null
  
)

export default component.exports